import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchGamesList(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game', {params: queryParams})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGame(ctx, {id}) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addGame(ctx, {game}) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/game/create', game)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        saveGame(ctx, {id, game}) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game/${id}`, game)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteGame(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/game/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        topicslist(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`autotopic/list`, {params: queryParams})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGameWeeks(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game-week')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        submitSchedule(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/game-schedule/import', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createWeekPosts(ctx, { week_id, days, create_full }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/create-posts`, { days, create_full })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchWeekGames(ctx, { week_id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game-week/${week_id}/games`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchWeekSummary(ctx, { week_id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game-week/${week_id}/summary`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishWeekSummary(ctx, { week_id, text }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/summary/publish`, { text })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGameReminders(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game-reminders')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        reviveReminder(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-reminders/${id}/revive`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishRating(ctx, { text, musicBlob, moviesBlob }) {
            const formData = new FormData()
            formData.append('text', text)
            formData.append('music_image', musicBlob, 'rating-music.png')
            formData.append('movies_image', moviesBlob, 'rating-movies.png')

            return new Promise((resolve, reject) => {
                axios
                    .post('/game-week/rating/publish', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
